import { Injectable } from '@angular/core';
import {Http, Headers} from '@angular/http';

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';
import { Observable } from 'rxjs/Rx';
import {Service} from "../shared/services/service";
import {Funcoes} from "../funcoes";

@Injectable()
export class AssinantesService extends Service{

  protected url: string = this.dominio+"/adm/assinantes/";

  constructor(protected http: Http, protected func: Funcoes) {
    super();
  }

  deletarCertificado(id){

    let headers = this.getHeaderLogado();

    return this.http.delete(this.url + 'delete-certificado/' + id, {headers})
      .map(res => {
        let json = res.json();
        if(json.Success){
          this.trataSucesso(res);
        }else{
          this.trataErro(json);
        }
        return json;
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/assinantes/assinantes.service.ts